export class SapAgent {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "deploymentShape",
            "baseName": "deploymentShape",
            "type": "SapDeploymentShape",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SapAgentStatus",
            "format": ""
        },
        {
            "name": "agentVersion",
            "baseName": "agentVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "contractVersion",
            "baseName": "contractVersion",
            "type": "number",
            "format": ""
        },
        {
            "name": "compatibilityStatus",
            "baseName": "compatibilityStatus",
            "type": "SapCompatibilityStatus",
            "format": ""
        },
        {
            "name": "compatMatrix",
            "baseName": "compatMatrix",
            "type": "SapCompatMatrix",
            "format": ""
        },
        {
            "name": "desiredVersion",
            "baseName": "desiredVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "previousVersion",
            "baseName": "previousVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "upgrade",
            "baseName": "upgrade",
            "type": "SapAgentUpgrade",
            "format": ""
        },
        {
            "name": "commands",
            "baseName": "commands",
            "type": "Array<SapAgentCommand>",
            "format": ""
        },
        {
            "name": "cursors",
            "baseName": "cursors",
            "type": "Array<SapAgentCursor>",
            "format": ""
        },
        {
            "name": "events",
            "baseName": "events",
            "type": "Array<SapEvent>",
            "format": ""
        },
        {
            "name": "lastHeartbeat",
            "baseName": "lastHeartbeat",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "cdcLagSeconds",
            "baseName": "cdcLagSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SapAgent.attributeTypeMap;
    }
    constructor() {
    }
}
